@if (changeForm) {
  <app-enfaf-modal
    [title]="'GOD_ORDERS.EDIT_DATE.TITLE' | translate"
    [subtitle]="subtitle"
    [buttonCancelText]="'GOD_ORDERS.EDIT_DATE.CANCEL' | translate"
    [buttonConfirmText]="'GOD_ORDERS.EDIT_DATE.CONFIRM' | translate"
    [disableConfirmButton]="changeForm.invalid || isUnchanged || isChangingDate"
    [isLoading]="isChangingDate"
    [showCloseButton]="true"
    [compactContent]="true"
    (onClose)="confirmCloseModal()"
    (onConfirm)="changeOrderDate()"
  >
    <form class="edit-date" data-testid="edit-date-modal" [formGroup]="changeForm" autocomplete="off" (ngSubmit)="changeOrderDate()">
      <enfaf-datetime-picker-light
        [control]="dateControl"
        name="date"
        [label]="'GOD_ORDERS.EDIT_DATE.LABEL' | translate"
        [errorLabel]="fieldErrorLabel"
        placeholder="dd/mm/aaaa"
        autocomplete="off"
        [hideTime]="hideTime"
        [minDate]="minDate"
        [maxDate]="maxDate"
      />
      @if (apiError) {
        <p class="edit-date__error" role="alert" data-testid="edit-date-error">{{ apiError }}</p>
      }
    </form>
  </app-enfaf-modal>
}
